import "./Modal.scss";

function Modal({ isOpen, onClose, title, children, size, noHeader }) {
  return (
    <div
      className={`privacy-modal-backdrop ${isOpen ? "active" : ""} ${noHeader ? "no-header" : ""}`}
      onClick={onClose}
    >
      <div
        className={`privacy-modal-content ${isOpen ? "active" : ""} ${
          size === "large" ? "large" : ""
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {!noHeader && (
          <div className="title-close">
            <h2 className="title-font">{title}</h2>
            <button onClick={onClose} className="privacy-modal-close" aria-label="Fermer">
              &times;
            </button>
          </div>
        )}
        {children}
      </div>
    </div>
  );
}

export default Modal;
